import React, { useState, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Morse() {
  const [text, setText] = useState("");
  const [code, setCode] = useState("");

  const morseCode = {
    A: ".-", B: "-...", C: "-.-.", D: "-..", E: ".", F: "..-.",
    G: "--.", H: "....", I: "..", J: ".---", K: "-.-", L: ".-..",
    M: "--", N: "-.", Ñ: "--.--", O: "---", P: ".--.", Q: "--.-", R: ".-.",
    S: "...", T: "-", U: "..-", V: "...-", W: ".--", X: "-..-",
    Y: "-.--", Z: "--..",
    "1": ".----", "2": "..---", "3": "...--", "4": "....-", "5": ".....",
    "6": "-....", "7": "--...", "8": "---..", "9": "----.", "0": "-----",
    " ": "/",
    ".": ".-.-.-", ",": "--..--", "?": "..--..", "'": ".----.", "!": "-.-.--",
    "/": "-..-.", "(": "-.--.", ")": "-.--.-", "&": ".-...", ":": "---...",
    ";": "-.-.-.", "=": "-...-", "+": ".-.-.", "-": "-....-", "_": "..--.-",
    '"': ".-..-.", "$": "...-..-", "@": ".--.-."
  };

  const letters = Object.entries(morseCode).filter(([char]) => /[A-ZÑ]/.test(char));
  const symbols = Object.entries(morseCode).filter(([char]) => !/[A-ZÑ]/.test(char));
  const chunk = (arr, size) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
      arr.slice(i * size, i * size + size)
    );

  const renderTable = (data, title) => (
    <div className="table-wrapper">
      <table>
        <caption className="table-title">{title}</caption>
        <tbody>
          {chunk(data, 3).map((row, i) => (
          <tr key={i}>
            {row.map(([char, code]) => (
              <React.Fragment key={char}>
                <td>{char === " " ? "\u00A0" : char}</td>
                <td className="code">{code}</td>
              </React.Fragment>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
 );

  const textFromCode = Object.entries(morseCode).reduce((acc, [key, value]) => {
    acc[value] = key;
    return acc;
  }, {});

  const textToCode = (input) => {
    if (!input) return "";
    return input
      .split("")
      .map((char) => morseCode[char] || "▯")
      .join(" ");
  };

  const codeToText = (input) => {
    if (!input) return "";
    return input
      .trim()
      .split("/")
      .map((word) =>
        word
          .trim()
          .split(" ")
          .filter((code) => code !== "")
          .map((code) => textFromCode[code] || "▯")
          .join("")
      )
      .join(" ");
  };

  const handleTextChange = (e) => {
    let value = e.target.value.toUpperCase();
    setText(value);
    textToCode(value);
  };

  const handleCodeChange = (e) => {
    let value = e.target.value.replace(/[^.\-/ ]/g, "");
    setCode(value);
    codeToText(value);
  };

  useEffect(() => {
    if (document.activeElement.name === "text") {
      setCode(textToCode(text));
    } else if (document.activeElement.name === "code") {
      setText(codeToText(code));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text, code]);

  return (
  <>
    <HelmetProvider>
      <Helmet>
        <title>Morse | ERI</title>
      </Helmet>
    </HelmetProvider>
    <div id="ciphers" className="content">
      <div id="morse" className="content-wrapper">
        <div className="content-title">
          <h1 className="title">Morse</h1>
          <p className="subtitle">El código morse, es un sistema de representación de letras y números mediante señales emitidas de forma intermitente.</p>
        </div>
        <div className="content-main">
          <div className="content-code">
            <div className="content-encrypt">
              <label className="text-left" htmlFor="code">Morse</label>
              <textarea id="input-code" className="input-left" name="code" value={code} spellCheck="false"
                onChange={handleCodeChange}
              />
              <span className="info info-left">Carácteres permitidos: .- /</span>
              <div className="buttons">
                <button className="btn btn-primary" onClick={() => setCode(textToCode(text))}><span>Cifrar </span><i className="fas fa-arrow-right"></i></button>
                <button className="btn btn-primary" onClick={() => setText(codeToText(code))}><i className="fas fa-arrow-left"></i><span> Descrifrar</span></button>
              </div>
              <label className="text-right" htmlFor="text">Texto</label>
              <textarea id="input-text" className="input-right" name="text" value={text} spellCheck="false"
                onChange={handleTextChange}
              />
              <span className="info info-right">Carácteres permitidos: Todos</span>
            </div>
          </div>
          <div className="content-table">
            {renderTable(letters, "Tabla de letras")}
            {renderTable(symbols, "Tabla de números y símbolos")}
          </div>
        </div>
      </div>
    </div>
  </>
  );
}
